import PropTypes from 'prop-types';
import Image from 'next/image';
import parse from 'html-react-parser';
import GradientDivider from '../gradientDivider/gradientDivider';
import styles from './disclaimer.module.scss';

export default function Disclaimer({
  tc = '',
  footNotes = [],
  disclaimerDynamicFooter = '',
  disclaimerDynamicFooterNoSnippet = false,
  disclaimerDynamicFooterNewUsers = '',
  disclaimerDynamicFooterNewUsersNoSnippet = false,
  disclaimerGlobalFooter = '',
  disclaimerGlobalFooterNoSnippet = false,
  disclaimerLogos = [],
}) {
  return (
    <>
      <div className={styles.dividerWrapper}>
        <GradientDivider />
      </div>
      <div className={styles.disclaimer}>
        <div className={styles.disclaimerContainer}>
          {tc && <div className={styles.tc}>{parse(`${tc}`)}</div>}
          {footNotes && (
            <div className={styles.footnotes}>
              <ul className={styles.ul}>
                {footNotes?.map(({ text, noSnippet }, index) => {
                  const numbered = text.replace(
                    /<p(\s[^>]*)?>/i,
                    `<p$1><sup class="${styles.footnoteNumber}">${
                      index + 1
                    }</sup>`
                  );
                  return (
                    <li
                      className={styles.disclaimerList}
                      key={`fn-${index}`.toString()}
                    >
                      {noSnippet ? (
                        <div {...{ 'data-nosnippet': '' }}>
                          {parse(numbered)}
                        </div>
                      ) : (
                        parse(numbered)
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {disclaimerDynamicFooterNewUsers && (
            <div
              {...(disclaimerDynamicFooterNewUsersNoSnippet && {
                'data-nosnippet': '',
              })}
              className={styles.disclaimerDynamicFooter}
            >
              {parse(`${disclaimerDynamicFooterNewUsers}`)}
            </div>
          )}
          {disclaimerDynamicFooter && (
            <div
              {...(disclaimerDynamicFooterNoSnippet && {
                'data-nosnippet': '',
              })}
              className={styles.disclaimerDynamicFooter}
            >
              {parse(`${disclaimerDynamicFooter}`)}
            </div>
          )}
          {disclaimerGlobalFooter && (
            <div
              {...(disclaimerGlobalFooterNoSnippet && {
                'data-nosnippet': '',
              })}
              className={styles.disclaimerGlobalFooter}
            >
              {parse(`${disclaimerGlobalFooter}`)}
            </div>
          )}
          {disclaimerLogos?.length > 0 && (
            <div className={styles.disclaimerLogos}>
              {disclaimerLogos.map((logo, index) => (
                <Image
                  key={`logo-${index}`.toString()}
                  src={logo.url}
                  alt={logo.alt || ''}
                  width={logo.width}
                  height={logo.height}
                  className={styles.disclaimerLogo}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

Disclaimer.propTypes = {
  tc: PropTypes.string,
  footNotes: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      noSnippet: PropTypes.bool,
    })
  ),
  disclaimerDynamicFooter: PropTypes.string,
  disclaimerDynamicFooterNoSnippet: PropTypes.bool,
  disclaimerDynamicFooterNewUsers: PropTypes.string,
  disclaimerDynamicFooterNewUsersNoSnippet: PropTypes.bool,
  disclaimerGlobalFooter: PropTypes.string,
  disclaimerGlobalFooterNoSnippet: PropTypes.bool,
  disclaimerLogos: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      alt: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    })
  ),
};
